
import {Component, Prop, Vue} from "vue-property-decorator";
import {ModulYetkiSatiri, YetkiKademe} from "@/enum/YetkiModulleri";

@Component
export default class IslemSecici extends Vue {
  @Prop({type: Object, required: true}) satir!: ModulYetkiSatiri;
  @Prop({type: Boolean, default: false}) readonly!: boolean;
  // Kişiye özel yetki modalı: alan -> ipucu metni. Dolu alanın düğmesinde kullanıcı simgesi çıkar.
  // Boş (varsayılan) = matris ekranındaki gibi simge yok.
  @Prop({type: Object, default: () => ({})}) ozelIsaretleri!: { [alan: string]: string };

  islemler: Array<{ alan: "ekle" | "degistir" | "sil"; label: string; icon: string }> = [
    {alan: "ekle", label: "Ekle", icon: "mdi-plus"},
    {alan: "degistir", label: "Değiştir", icon: "mdi-pencil"},
    {alan: "sil", label: "Sil", icon: "mdi-delete-outline"},
  ];

  get devreDisi(): boolean {
    return this.readonly || this.satir.kademe !== YetkiKademe.DUZENLE;
  }

  // Eski checkbox v-model="satir[alan]" ile aynı: satırdaki boolean bayrağı çevirir.
  // (Alan satir objesinde zaten tanımlı olduğu için Vue 2 reaktivitesi korunur.)
  degistir(alan: "ekle" | "degistir" | "sil") {
    if (this.devreDisi) {
      return;
    }
    this.satir[alan] = !this.satir[alan];
  }
}
